/**
 * Slot Check Search display settings from applicationConfigurations, with the
 * same code fallbacks + clamps as ms-casino lib/universalSearch.ts. The API
 * response also echoes the resolved values (response.config), which win once a
 * search has run; these are used before the first response (drawer start).
 */
import { getConfig } from 'lib/applicationConfig';

export const UNIVERSAL_SEARCH_DRAWER_START_DEFAULT = 50;
export const UNIVERSAL_SEARCH_CARDS_PER_GROUP_DEFAULT = 3;
/** Before any search: only the handle, title, subtitle and prompt show (map + pins stay visible). */
export const UNIVERSAL_SEARCH_DRAWER_EMPTY_DEFAULT = 20;
/** After a search the map keeps this many top casinos (by matching EGMs) in view. */
export const UNIVERSAL_SEARCH_MAP_TOP_CASINOS_DEFAULT = 3;

export function clampConfigInt(v: unknown, min: number, max: number, fallback: number): number {
  if (v === null || v === undefined || (typeof v === 'string' && v.trim() === '')) return fallback;
  const n = typeof v === 'number' ? v : Number(v);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, Math.round(n)));
}

export function getUniversalSearchDrawerStartPercent(): number {
  return clampConfigInt(
    getConfig<unknown>('universalSearchDrawerStartPercent', UNIVERSAL_SEARCH_DRAWER_START_DEFAULT),
    25,
    80,
    UNIVERSAL_SEARCH_DRAWER_START_DEFAULT
  );
}

export function getUniversalSearchDrawerEmptyPercent(): number {
  return clampConfigInt(
    getConfig<unknown>('universalSearchDrawerEmptyPercent', UNIVERSAL_SEARCH_DRAWER_EMPTY_DEFAULT),
    10,
    50,
    UNIVERSAL_SEARCH_DRAWER_EMPTY_DEFAULT
  );
}

export function getUniversalSearchMapTopCasinos(): number {
  return clampConfigInt(
    getConfig<unknown>('universalSearchMapTopCasinos', UNIVERSAL_SEARCH_MAP_TOP_CASINOS_DEFAULT),
    1,
    10,
    UNIVERSAL_SEARCH_MAP_TOP_CASINOS_DEFAULT
  );
}

export function getUniversalSearchCardsPerGroup(): number {
  return clampConfigInt(
    getConfig<unknown>('universalSearchCardsPerGroup', UNIVERSAL_SEARCH_CARDS_PER_GROUP_DEFAULT),
    1,
    10,
    UNIVERSAL_SEARCH_CARDS_PER_GROUP_DEFAULT
  );
}
